import { getNewsArticle } from '../../api/AWIntegrations/NewsArticles';
import { newsQueryKeys } from './queryKeys';

/**
 * TanStack Query object for news article.
 * Use with useSuspenseQuery or useQuery in components.
 */
export const newsArticleQuery = (params: { articleId: string; pkg: string; platformId: string }) => ({
  queryKey: newsQueryKeys.article(params),
  queryFn: async () => {
    const response = await getNewsArticle(params);
    return response.data;
  },
});
